// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__drfe7","header":"PatientQuestionnaire_header__w11Gu","info":"PatientQuestionnaire_info__2mjum"};